import { useContext } from "react";
import UserContext from "./UserContext";

export default function PermissionGuard({ permission, permissions, orPermissions, children, fallbackComponent = null }) {
	const env = useContext(UserContext);
	const userPermissions = env.userPermissions || [];
	if (permission) {
		if (!userPermissions.includes(permission)) {
			return fallbackComponent;
		}
	}

	if (permissions) {
		const hasAll = permissions.every((perm) => userPermissions.includes(perm));
		if (!hasAll) {
			return fallbackComponent;
		}
	}

	if (orPermissions) {
		const hasAny = orPermissions.some((perm) => userPermissions.includes(perm));
		if (!hasAny) {
			return fallbackComponent;
		}
	}

	return <>{children}</>;
}
